import React from 'react'
import { Door } from 'apis/door/TopPageDoorsV1'
import DummyHeader from 'images/dummy_header.jpg'
import DefaultUserIcon from 'images/default_user_icon.jpg'
import { IMAGE_OPTIMIZER } from '../../constants'

interface Props {
  door: Door
}

export default function DoorCard(props: Props) {
  const { door } = props
  // door.iconが無い場合はデフォルトの画像を表示する
  const userIcon = door.icon ? door.icon : DefaultUserIcon

  return (
    <>
      <li>
        <a
          href={`${process.env.REACT_APP_YOOR_URL!}door/${door.id}`}
          className="list-recommend__item"
        >
          <div className="header">
            {door.free_trial_period && (
              <div className="batch">
                <strong>無料期間あり</strong>
              </div>
            )}
            <img
              src={`${door.header}?${IMAGE_OPTIMIZER.size.thumbnails}`}
              onError={(e) => {
                let target = e.target as HTMLImageElement
                target.src = DummyHeader
              }}
              alt="header"
            />
          </div>
          <div className="body">
            <div className="title">{door.title}</div>
            <div className="user">
              <div className="icon">
                <img src={userIcon} alt="" />
              </div>
              <div className="sub">{door.username}</div>
            </div>
          </div>
        </a>
      </li>
    </>
  )
}
